import CommonProxy from '@/classes/utilities/CommonProxy'

const modes = {
  IN_OUT: 'in-out',
  OUT_IN: 'out-in',
  DEFAULT: '',
}

export default CommonProxy.readOnly(modes)
